/* eslint-disable @typescript-eslint/no-magic-numbers */
import type { MongoQuery } from "@ucast/mongo2js";
import {
  // IsDefined,
  IsNotEmpty,
  IsObject,
  IsOptional,
  MaxLength, // MinLength,
  // NotContains,
  // ValidateNested,
} from "class-validator";

import "reflect-metadata";

import type {
  IFormAttributes,
  IGridAttributes,
  IValidationParams,
  TJsonTypeOption,
} from "../../models";

export class CustomFieldDto {
  id: number;

  companyId?: number;

  /** Read-only: company name filled by the list endpoint (`--` when the field is global). */
  companyTitle?: string;

  @IsNotEmpty()
  entityId: number;

  @MaxLength(255)
  @IsNotEmpty()
  name: string;

  isColumn: boolean;

  @MaxLength(255)
  @IsOptional()
  jsonType?: TJsonTypeOption;

  @MaxLength(255)
  @IsOptional()
  formLabel?: string;

  @IsOptional()
  @MaxLength(6)
  formLabelColor?: string;

  formFieldTypeId: number;

  @IsOptional()
  @IsObject()
  formValidation: Record<string, IValidationParams>;

  @IsOptional()
  @IsObject()
  formAttributes?: IFormAttributes;

  @IsOptional()
  @IsObject()
  formVisibleCondition?: MongoQuery;

  gridFieldTypeId: number;

  @IsOptional()
  @MaxLength(255)
  gridLabel?: string;

  gridOrderable?: boolean;

  gridSortable?: boolean;

  gridGroupable?: boolean;

  gridAttributes?: IGridAttributes;

  @IsOptional()
  @IsObject()
  gridVisibleCondition?: MongoQuery;

  readPermissionId?: number;

  updatePermissionId?: number;

  filterFieldTypeId?: number;

  filterSearchable?: boolean;

  @IsOptional()
  @IsObject()
  filterAttributes?: object;
}

// export class CustomFieldDto {

//   id: number;

//   @IsInt()
//   @IsOptional()
//   companyId?: number;

//   @IsInt()
//   entityId: number;

//   @IsString()
//   @IsNotEmpty()
//   @NotContains(".")
//   @MaxLength(255)
//   name: string;

//   @IsBoolean()
//   @IsOptional()
//   isColumn: boolean;

//   @IsString()
//   @IsNotEmpty()
//   @MaxLength(255)
//   jsonType?: TJsonTypeOption;

//   @IsString()
//   @IsNotEmpty()
//   @MaxLength(255)
//   formLabel?: string;

//   @IsString()
//   @IsOptional()
//   @MaxLength(6)
//   formLabelColor?: string;

//   @IsInt()
//   @IsOptional()
//   formFieldTypeId: number;

//   @IsDefined()
//   // @IsObject()
//   // @ValidateNested()
//   @IsOptional()
//   formValidation: Record<string, IValidationParams>;

//   @IsDefined()
//   // @IsObject()
//   // @ValidateNested()
//   @IsOptional()
//   formAttributes?: IFormAttributes;

//   @IsDefined()
//   // @IsObject()
//   // @ValidateNested()
//   @IsOptional()
//   formVisibleCondition?: MongoQuery;

//   @IsInt()
//   @IsOptional()
//   gridFieldTypeId: number;

//   @IsString()
//   @IsOptional()
//   @MaxLength(255)
//   gridLabel?: string;

//   @IsBoolean()
//   @IsOptional()
//   gridOrderable?: boolean;

//   @IsBoolean()
//   @IsOptional()
//   gridSortable?: boolean;

//   @IsBoolean()
//   @IsOptional()
//   gridGroupable?: boolean;

//   @IsDefined()
//   // @IsObject()
//   // @ValidateNested()
//   @IsOptional()
//   gridAttributes?: IGridAttributes;

//   @IsInt()
//   @IsOptional()
//   readPermissionId?: number;

//   @IsInt()
//   @IsOptional()
//   updatePermissionId?: number;

//   @IsInt()
//   @IsOptional()
//   filterFieldTypeId?: number;

//   @IsBoolean()
//   @IsOptional()
//   filterSearchable?: boolean;

//   // @IsObject()
//   @IsOptional()
//   filterAttributes?: object;
// }
